import Vue from 'vue'

export default (payload) =>
  Vue.$http.put(`commons/notifications/`, payload)
    .then(({ data }) => data)
